import { Fragment, type ReactNode } from 'react';
import { ChildListSchema, DynamicStringSchema } from '@a2ui/web_core/v0_9';
import { createComponentImplementation } from '@a2ui/react/v0_9';
import { defineA2uiComponentSchema } from '../../a2ui-schema';
import { CopyQuote } from './CopyQuote';

interface ResolvedProps {
  readonly accountName: string;
  /** Child QuoteOption component IDs, in display order. */
  readonly children?: readonly string[];
  readonly sourceQuoteNumber?: string;
  readonly sourceLimit?: string;
  readonly sourcePremium?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const schema = defineA2uiComponentSchema({
  accountName: DynamicStringSchema,
  children: ChildListSchema,
  sourceQuoteNumber: DynamicStringSchema,
  sourceLimit: DynamicStringSchema,
  sourcePremium: DynamicStringSchema,
}) as any;

export const CopyQuoteImpl = createComponentImplementation(
  { name: 'CopyQuote', schema },
  ({
    props,
    buildChild,
  }: {
    props: ResolvedProps;
    buildChild: (childId: string) => ReactNode;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    context: any;
  }) => (
    <CopyQuote
      accountName={props.accountName ?? ''}
      sourceQuoteNumber={props.sourceQuoteNumber}
      sourceLimit={props.sourceLimit}
      sourcePremium={props.sourcePremium}
    >
      {(Array.isArray(props.children) ? props.children : []).map((childId) => (
        <Fragment key={childId}>{buildChild(childId)}</Fragment>
      ))}
    </CopyQuote>
  )
);
